import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'da-page-not-found',
    templateUrl: './page-not-found.component.html',
    styleUrls: ['./page-not-found.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class PageNotFoundComponent implements OnInit {
    constructor(private _route: ActivatedRoute, private _router: Router) {}

    ngOnInit(): void {
        window.scrollTo(0, 0);
        if (this._route.snapshot.url[0] && this._route.snapshot.url[0].path.toLowerCase() !== this._route.snapshot.url[0].path) {
            this._router.navigate([this._route.snapshot.url[0].path.toLowerCase()]);
        }
    }
}
